import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import useCondition from '../../../useCondition';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {prospectStages} from 'helpers/prospectStages';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();

  if (!condition?.stages || !condition.stages.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">ステージ</h4>
        <button
          onClick={() => setFilterType('stage')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setCondition({stages: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex gap-1">
        {prospectStages
          .filter((stage) => condition.stages.includes(stage.name))
          .map((stage) => (
            <span
              key={stage.name}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {stage.displayName}
            </span>
          ))}
      </div>
    </div>
  );
};
